export enum SeasonEntityTableColumns {
  Image = "image",
  NameFullLocal = "nameFullLocal",
  NameFullLatin = "nameFullLatin",
  CodeLocal = "codeLocal",
  CodeLatin = "codeLatin",
  EntityId = "entityId",
  ExternalId = "externalId",
  Gender = "gender",
  AgeGroup = "ageGroup",
  Standard = "standard",
  Discipline = "discipline",
  EntityStatus = "entityStatus",
  Status = "status",
  ConferenceName = "conferenceName",
  DivisionName = "divisionName",
  RosterStatus = "rosterStatus",
  Seed = "seed",
}
